import './UAMFirstSteps.scss'

import * as lottie_mail from '../../lotties/UAMFirstSteps/mail.json'
import * as lottie_message from '../../lotties/UAMFirstSteps/message.json'

import Lottie from 'react-lottie'
import { animated } from 'react-spring'
import AddressBookComp from '../../components/AddressBook/AddressBook'
import { ModalContainer } from '../../components/Containers/ModalContainer'
import { SectionContainer } from '../../components/Containers/SectionContainer'
import Desplegable from '../../components/Desplegable/Desplegable'
import ExternalLink from '../../components/ExternalLink/ExternalLink'
import Href from '../../components/Href/Href'
import ListItem from '../../components/ListItem/ListItem'
import MailBox from '../../components/MailBox/MailBox'
import VerticalWaves from '../../components/VerticalWaves/VerticalWaves'
import { contacts } from '../../data'

const UAMFirstSteps = ({ color = 'orange', secondary = 'dark-blue', scrollRight, modalHandling, closeModal, section, parallax, setLock }) => {
  // Lotties

  // https://lottiefiles.com/16763-animated-mail-illustration
  const lottieMail = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_mail.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )
  // https://lottiefiles.com/24910-new-message-notification
  const lottieMessage = (
    <Lottie
      options={{
        loop: false,
        autoplay: true,
        animationData: lottie_message.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // Modals area
  const idUAM = (
    <ModalContainer secondary={secondary} color={color} title="Activa tu ID-UAM" onClick={() => closeModal()}>
      {lottieMessage}
      <p>
        Después de matricularte, <b>habrás recibido un mensaje</b> en el que se te informa de tu identificador asignado (ID-UAM),{' '}
        <b>así como del código con el que poder activarlo</b>.
      </p>
      <p>
        Utilizarás el ID-UAM para <b>acceder a los diferentes servicios telemáticos</b> de la Autónoma, <b>incluido el correo electrónico</b>.
      </p>
      <p>
        <b>Para activarlo</b>, accede al <Href href="https://autoservicio.uam.es">Autoservicio UAM</Href> y sigue las instrucciones del mensaje recibido para
        utilizar el código de activación. En esta web podrás recuperar tu contraseña o cambiarla cuando lo necesites.
      </p>
      <ExternalLink url="https://autoservicio.uam.es" text="Autoservicio UAM" color={secondary} secondary={color} />
    </ModalContainer>
  )

  const emailAccount = (
    <ModalContainer secondary={secondary} color={color} title="Accede a tu cuenta de correo electrónico" onClick={() => closeModal()}>
      <p>
        Como estudiante de la UAM, debes usar el <b>ID-UAM como tu</b> dirección personal de correo electrónico:
      </p>
      {lottieMail}
      <div className="mail-box">
        <p>nombre.apellido@estudiante.uam.es</p>
      </div>
      <p>
        <b>Es muy importante que accedas cuanto antes</b> y la uses siempre que escribas sobre asuntos relacionados con tus estudios. Si todavía no lo has
        hecho, <b>teclea “webmail uam” en el navegador</b> e introduce tu correo y contraseña.
      </p>
      <p>
        <b>No olvides revisar con frecuencia tu bandeja de entrada</b>: quizá no todos los mensajes sean de tu interés, pero en el entorno universitario{' '}
        <b>este es el canal a través del que recibirás información crucial</b> que deberías leer a tiempo.
      </p>
      <MailBox text={'correoweb.uam.es'} />
    </ModalContainer>
  )

  const uniCarnet = (
    <ModalContainer secondary={secondary} color={color} title="Solicita tu carné universitario" onClick={() => closeModal()}>
      <p>
        Es necesario para acreditarte y usar los servicios que integra. El carné tiene validez hasta que finalizas los estudios y no tiene <b>ningún coste</b>.
      </p>
      <img src="/carnet-estudiante.png" alt="Carné UAM" />
      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title={'¿Cómo obtenerlo?'}>
          <div className="desplegable-container how-obtain">
            <p>
              El carné es <b>completamente digital</b> y puedes visualizarlo a través de la UAM app (más info en sección CONFIGURA TU ENTORNO DIGITAL). Por
              defecto, en el Carné de Estudiante no se muestra ninguna foto personal, pero si quieres que aparezca una, deberás <b>reservar cita</b> para
              tomarte una foto de manera acreditada durante la campaña específica que se organiza al inicio del curso, tanto en el campus de Cantoblanco como en
              el de Medicina. Presta atención al correo electrónico para conocer las fechas.
            </p>
            <p>Este año se realizará:</p>
            <ul className={`list ${color}`}>
              <li>
                Campus <b>de Cantoblanco</b> (1ª planta Edificio Plaza Mayor UAM)
                <ul>
                  <li>
                    Del <b>8 de septiembre</b> al <b>9 de octubre</b>.
                  </li>
                </ul>
              </li>
              <br />
              <li>
                Campus <b>de Medicina</b> (hall de la Facultad)
                <ul>
                  <li>
                    Del <b>15 al 19 de septiembre</b>.
                  </li>
                </ul>
              </li>
            </ul>

            <ExternalLink text={'Más info sobre carné y reserva de citas'} url={'https://www.uam.es/uam/carne'} color={color} secondary={secondary} />

            <p>
              <b>Importante</b>: recuerda que si no acudes con cita no se visualizará tu foto en el carné.
            </p>
            <p>
              Una vez finalizada la campaña podrás subir tu foto a través de{' '}
              <Href href="https://www.uam.es/uam/tecnologias-informacion/servicios/foto-digital">este enlace</Href>, pero no será una foto acreditada y en el
              carné se mostrará un <b>logotipo</b> en lugar de la foto personal.
            </p>
            <p>
              Una vez hayas subido tu foto, acreditada o no, podrás disponer del carné en formato digital descargando <b>la AppUAM</b>.
            </p>

            <div className="logo-container uam-app">
              <img src="/svg/logos/logo-square-uam.svg" alt="" />
            </div>
            <div className="logo-container google-play">
              <img src="/svg/logos/google-play.png" alt="" />
            </div>
            <div className="logo-container apple-store">
              <img src="/svg/logos/apple-store.png" alt="" />
            </div>

            <p>También estaremos disponibles para resolver tus dudas en la Oficina UAM Estudiantes</p>
            <AddressBookComp
              color={color}
              data={{
                title: contacts['uam-estudiantes'].title,
                address: contacts['uam-estudiantes'].address,
                map: contacts['uam-estudiantes'].map,
                web: contacts['uam-estudiantes'].web
              }}
            />
          </div>
        </Desplegable>
        <hr />
        <Desplegable secondary={secondary} color={color} title={'¿Para qué sirve el carné UAM?'}>
          <div className="desplegable-container what-is-it-for">
            <ul className={`kite-list ${color}`}>
              <li>
                <ListItem color={color} kiteColor={secondary}>
                  Para el <b>préstamo de libros y portátiles</b> en las bibliotecas de la UAM.
                </ListItem>
              </li>
              <li>
                <ListItem color={color} kiteColor={secondary}>
                  Para reservar y utilizar las <b>instalaciones deportivas</b>.
                </ListItem>
              </li>
              <li>
                <ListItem color={color} kiteColor={secondary}>
                  Como <b>monedero</b> para realizar pequeños pagos en el campus, por ejemplo, en las fotocopiadoras situadas en los pasillos de cada centro.
                </ListItem>
              </li>
              <li>
                <ListItem color={color} kiteColor={secondary}>
                  Para <b>acreditar tu condición de estudiante</b> tanto dentro como fuera de la Universidad (y acceder así a las ventajas que ofrecen muchos
                  museos e instituciones).
                </ListItem>
              </li>
            </ul>
            <p>
              Puedes cargar el monedero en la <b>reprografía</b> (mira la sección GESTIONA TU DÍA A DÍA) y <b>online</b> a través de esta web, que solo será
              accesible si te conectas con <b>wifi desde el campus</b> o utilizando el <b>VPN UAM</b>".
            </p>
            <ExternalLink url="http://reprografia.uam.es/" color={secondary} secondary={color} text="Cargar el monedero" />
            <p>
              Escribe al <b>CAUTI</b> para solicitar un código de registro.
            </p>
            <ExternalLink url={`mailto://${contacts['cauti'].emails[0]}`} color={secondary} secondary={color} text={contacts['cauti'].emails[0]} />
          </div>
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const items = [
    { key: 'id-uam', content: idUAM, title: 'Activa tu ID UAM' },
    { key: 'email-account', content: emailAccount, title: 'Accede a tu cuenta de correo electrónico' },
    { key: 'uni-carnet', content: uniCarnet, title: 'Obtén tu Carné de Estudiante' }
  ]

  const Splash = (
    <>
      <div className="logo-back">
        <img src="/splash/svg/UAMFirstSteps_logo_back.svg" alt="" />
      </div>
      <animated.div className="logo-main" style={{ transform: parallax.logo_main(section) }}>
        <img src="/splash/png/UAMFirstSteps_logo_main.png" className="illustration" alt="" />
        <img src="/splash/png/UAMFirstSteps.png" className="image" alt="" />
      </animated.div>
      <div className="logo-front">
        <VerticalWaves color={secondary} />
      </div>
    </>
  )

  return (
    <SectionContainer
      // Section
      className={'UAMFirstSteps'}
      title={'Primeros pasos en la UAM'}
      // General
      color={color}
      secondary={secondary}
      items={items}
      setLock={setLock}
      section={section}
      // Mobile
      handleMobileModal={modalHandling}
      scrollRight={scrollRight}
    >
      {Splash}
    </SectionContainer>
  )
}

export default UAMFirstSteps
